import type { ComponentType } from 'react';
import {
  CreditProducts,
  Markets,
  Currency,
  Tenor,
  Status,
  MaturityDate,
  CallDate,
  CouponTypes,
  Rankings,
  Ratings,
  RatingAgencies,
  Benchmarks,
  Registrations,
  Size,
  AdditionalFilters,
  CouponRange,
  PricingSpread,
  Yield,
  IptPxd,
  XCovered,
  Attrition,
  IndustriesSubindustries,
  RegionsCountries,
  ParentsIssuers,
  Ticker,
  Esg,
  Listing,
  UseOfProceeds,
  Price,
  Leads,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

export interface ISectionEntry {
  id: FilterSectionIds,
  searchText: string,
  Component: ComponentType,
}

export const SECTIONS_REGISTRY: ISectionEntry[] = [
  { id: FilterSectionIds.CreditProducts, searchText: 'Credit Products', Component: CreditProducts },
  { id: FilterSectionIds.Markets, searchText: 'Markets', Component: Markets },
  { id: FilterSectionIds.Currency, searchText: 'Currency', Component: Currency },
  { id: FilterSectionIds.IndustriesSubindustries, searchText: 'Industries & Subindustries', Component: IndustriesSubindustries },
  { id: FilterSectionIds.RegionsCountries, searchText: 'Issuer Region & Countries', Component: RegionsCountries },
  { id: FilterSectionIds.Size, searchText: 'Size', Component: Size },
  { id: FilterSectionIds.Status, searchText: 'Status', Component: Status },
  { id: FilterSectionIds.ParentsIssuers, searchText: 'Issuer', Component: ParentsIssuers },
  { id: FilterSectionIds.Ticker, searchText: 'Ticker', Component: Ticker },
  { id: FilterSectionIds.Leads, searchText: 'Leads', Component: Leads },
  { id: FilterSectionIds.Rankings, searchText: 'Ranking', Component: Rankings },
  { id: FilterSectionIds.Tenor, searchText: 'Tenor at Issue (Years)', Component: Tenor },
  { id: FilterSectionIds.MaturityDate, searchText: 'Maturity Date', Component: MaturityDate },
  { id: FilterSectionIds.CallDate, searchText: 'Call Date', Component: CallDate },
  { id: FilterSectionIds.Ratings, searchText: 'Ratings', Component: Ratings },
  { id: FilterSectionIds.RatingAgencies, searchText: 'Rating Agencies', Component: RatingAgencies },
  { id: FilterSectionIds.CouponTypes, searchText: 'Coupon Type', Component: CouponTypes },
  { id: FilterSectionIds.CouponRange, searchText: 'Coupon Range', Component: CouponRange },
  { id: FilterSectionIds.Registrations, searchText: 'Registration Format', Component: Registrations },
  { id: FilterSectionIds.PricingSpread, searchText: 'Pricing Spread', Component: PricingSpread },
  { id: FilterSectionIds.Yield, searchText: 'Yield', Component: Yield },
  { id: FilterSectionIds.Price, searchText: 'Price', Component: Price },
  { id: FilterSectionIds.IptPxd, searchText: 'IPT PXD', Component: IptPxd },
  { id: FilterSectionIds.XCovered, searchText: 'X-Covered', Component: XCovered },
  { id: FilterSectionIds.Attrition, searchText: 'Attrition', Component: Attrition },
  { id: FilterSectionIds.Benchmarks, searchText: 'Benchmark', Component: Benchmarks },
  { id: FilterSectionIds.Listing, searchText: 'Listing', Component: Listing },
  { id: FilterSectionIds.UseOfProceeds, searchText: 'Use of Proceeds', Component: UseOfProceeds },
  { id: FilterSectionIds.Esg, searchText: 'ESG', Component: Esg },
  { id: FilterSectionIds.AdditionalFilters, searchText: 'Additional Filters', Component: AdditionalFilters },
];
